var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Copyright_wrap"},[_c('div',{staticClass:"Copyright_content_wrap"},[_c('img',{staticClass:"Copyright_content_img",attrs:{"src":_vm.IMG_LOGO_SUPPORT,"alt":"Copyright_img"}}),_c('span',{staticClass:"Copyright_content_text"},[_vm._v("技术支持")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }